var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Utils from '@datocms/rest-client-utils';
import BaseResource from '../../BaseResource';
var SsoSettings = /** @class */ (function (_super) {
    __extends(SsoSettings, _super);
    function SsoSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Retrieve SSO Settings
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/sso-settings/self
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    SsoSettings.prototype.find = function () {
        return this.rawFind().then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Retrieve SSO Settings
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/sso-settings/self
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    SsoSettings.prototype.rawFind = function () {
        return this.client.request({
            method: 'GET',
            url: '/sso-settings',
        });
    };
    /**
     * Generate SSO token
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/sso-settings/generate_token
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    SsoSettings.prototype.generateToken = function () {
        return this.rawGenerateToken().then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Generate SSO token
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/sso-settings/generate_token
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    SsoSettings.prototype.rawGenerateToken = function () {
        return this.client.request({
            method: 'PUT',
            url: '/sso-settings/generate-token',
        });
    };
    /**
     * Update SSO Settings
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/sso-settings/update
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    SsoSettings.prototype.update = function (body) {
        return this.rawUpdate(Utils.serializeRequestBody(body, {
            type: 'sso_settings',
            attributes: ['idp_saml_metadata_url', 'idp_saml_metadata_xml'],
            relationships: ['default_role'],
        })).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Update SSO Settings
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/sso-settings/update
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    SsoSettings.prototype.rawUpdate = function (body) {
        return this.client.request({
            method: 'PUT',
            url: '/sso-settings',
            body: body,
        });
    };
    SsoSettings.TYPE = 'sso_settings';
    return SsoSettings;
}(BaseResource));
export default SsoSettings;
//# sourceMappingURL=SsoSettings.js.map